const pricingPlans = {
    // English
    plansEN: [
        /*{
            planName: 'Monthly Pro',
            //planId: 'Monthly_Pro',
            planId: 'P-4D061750H9765871WLZA2X7I',
            currency: 'USD',
            periodicity: 'Per month',
            billed: 'Billed monthly',
            price: 13.99,
            color: 'black',
            icon: 'fa-star'
        },*/
        {
            planName: 'Annually Pro',
            planId: 'P-5F661739RM416263LLZULSDQ',
            currency: 'USD',
            periodicity: 'Per month',
            billed: 'Billed yearly',
            price: 13.5,
            color: 'blue',
            icon: 'fa-star'
        },
        {
            planName: 'Lifetime Pro',
            planId: 'Lifetime_Pro',
            currency: 'USD',
            periodicity: 'Forever',
            billed: 'Lifetime',
            price: 269,
            color: 'silver',
            icon: 'fa-star'
        },
    ],
    propertiesEN: [
        { text: 'Get insights of your trading activity', icon: 'fa-lightbulb'},
        { text: 'Get a spot on our Trading Tournaments', icon: 'fa-trophy'},
        { text: 'Multiple analytics of your trading', icon: 'fa-chart-pie'},
        { text: 'Automate your Futures/Forex platform', icon: 'fa-laptop'},
        { text: 'Import historic trades', icon: 'fa-cloud-upload-alt'},
        { text: 'More than 20 amazing features...', icon: 'fa-angle-double-right'},
    ],

    // Spanish
    plansES: [
        /*{
            planName: 'Pro Mensual',
            planId: 'P-4D061750H9765871WLZA2X7I',
            currency: 'USD',
            periodicity: 'Por mes',
            billed: 'Facturado mensualmente',
            price: 13.99,
            color: 'black',
            icon: 'fa-star'
        },*/
        {
            planName: 'Pro Anual',
            planId: 'P-5F661739RM416263LLZULSDQ',
            currency: 'USD',
            periodicity: 'Por mes',
            billed: 'Facturado anualmente',
            price: 13.25,
            color: 'blue',
            icon: 'fa-star'
        },
        {
            planName: 'Pro Lifetime',
            planId: 'Lifetime_Pro',
            currency: 'USD',
            periodicity: 'De por vida',
            billed: 'Una sola vez',
            price: 269,
            color: 'silver',
            icon: 'fa-star'
        },
    ],
    propertiesES: [
        { text: 'Insights automáticos de tu actividad de trading', icon: 'fa-lightbulb'},
        { text: 'Plan de trading ajustado a tus necesidades', icon: 'fa-book'},
        { text: 'Reserva gratis tu lugar en nuestros torneos', icon: 'fa-trophy'},
        { text: 'Multiples analíticas de tu trading', icon: 'fa-chart-pie'},
        { text: 'Automatiza tu plataforma de Futuros/Forex', icon: 'fa-laptop'},
        { text: 'Importa trades históricos inmediatamente', icon: 'fa-cloud-upload-alt'},
        { text: 'Otras 20+ increíbles características Pro...', icon: 'fa-angle-double-right'},
    ],
};

export default pricingPlans;
